import React, { useMemo } from 'react'
import Box from '@cloudscape-design/components/box'
import { useSelector } from 'react-redux'
import { getStoreId as getStoreIdFromRedux } from '@atredux/selectors/storeSelector'
import { getToolUrl } from '@services/ToolMenuConfigService'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import './RefundsView.scss'

/**
 * Display name and asset id must equal what JWOStoreManagementPlatformRegistration registers;
 * getToolUrl resolves the iframe src from that pair.
 */
const REFUNDS_DISPLAY_NAME = 'Refunds'
const REFUNDS_ASSET_ID = 'jwo-refund-management-app'

const RefundsView: React.FC = () => {
    const storeId = useSelector(getStoreIdFromRedux)
    const [bundle] = useBundle(BUNDLE_NAME)
    // getToolUrl reads the store from Redux; storeId in deps reloads the iframe on store switch.
    const refundsUrl = useMemo(() => getToolUrl(REFUNDS_DISPLAY_NAME, REFUNDS_ASSET_ID) || '', [storeId])

    if (!refundsUrl) {
        return (
            <Box padding="l" color="text-status-inactive">
                {t(bundle, 'jsma-web-operations-refundsUnavailable')}
            </Box>
        )
    }

    return (
        <div className="operations-refunds-container" data-atb-id="operations-refunds-container">
            <iframe
                className="operations-refunds-frame"
                data-atb-id="operations-refunds-frame"
                title={t(bundle, 'jsma-web-operations-refundsTitle')}
                aria-label={t(bundle, 'jsma-web-operations-refundsTitle')}
                src={refundsUrl}
            />
        </div>
    )
}

export default RefundsView
